import React, { useCallback, useEffect, useState } from "react";

import "../../../Assets/CSS/bulkorder.css";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import axios from "axios";
import moment from "moment";
import { ClipLoader } from "react-spinners";
import OMSOverdue from "./omsOverdue";
import { useNavigate } from "react-router-dom";

function OMSApproved({ state, searchOrderId, overDueAgenstLoading }) {
  const [loadingData, setLoadingData] = useState([]);
  const navigate = useNavigate();
  const [omsData, setOmsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const [itemPerPage, setItemPerPage] = useState(15);
  const [pageNumberLimit, setPageLimit] = useState(15);
  const [maxPageLimit, setMaxLimit] = useState(5);
  const [minPageLimit, setMinLimit] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const getOMSData = useCallback(async () => {
    // Commented for all orders
    // if(
    //   state.supplier_loading === '' &&
    //   state.buyer_unloading === '' &&
    //   state.shipping_status === '' &&
    //   state.supplier_status === '' &&
    //   state.approval === '' &&
    //   state.grn_document_oms === '' &&
    //   searchOrderId === '')
    // {
    //   setTotalResults(0);
    //     setOmsData([]);
    //   return;
    // }
    let apiPrefix = "/api/oms/orders?";
    if (state.payment_info) {
      apiPrefix = `/api/oms/orders_with_payment_info?payment_info=${state.payment_info}&`;
    }
    if (state.supplier_payment_info) {
      apiPrefix = `/api/oms/orders_with_payment_info?supplier_payment_info=${state.supplier_payment_info}&`;
    }
    const url = `${apiPrefix}page=${currentPage}&limit=${itemPerPage}&order_id=${searchOrderId}&supplier_loading=${
      state.supplier_loading
    }&ayekart_loan_status=${
      state.approval === "Overdue" ? "Approved" : state.approval
    }&buyer_unloading=${state.buyer_unloading}&shipping_status=${
      state.shipping_status
    }&supplier_status=${state.supplier_status}&grn_document_oms=${
      state.grn_document_oms
    }&decending_order=true`;

    try {
      setLoading(true);
      const { data } = await axios.get(url);
      if (data.status) {
        setTotalResults(data?.orders?.count);
        setOmsData(data?.orders?.rows);
      } else {
        setTotalResults(0);
        setOmsData([]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [page, currentPage, searchOrderId, state]);

  useEffect(() => {
    let token;
    if (searchOrderId) {
      clearTimeout(token);
      token = setTimeout(() => {
        getOMSData();
      }, 1000);
    } else {
      getOMSData();
    }
    return () => clearTimeout(token);
  }, [page, currentPage, searchOrderId, state]);

  const pages = [];
  const handleClick1 = (event) => {
    setCurrentPage(Number(event.target.id));
    setPage(Number(event.target.id));
  };
  for (let i = 1; i <= Math.ceil(totalResults / itemPerPage); i++) {
    pages.push(i);
  }
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItem = loadingData.results?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePrevBtn = (e) => {
    if (currentPage === pages[0]) {
      return;
    }
    setPage(currentPage - 1);
    setCurrentPage(currentPage - 1);
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxLimit(maxPageLimit - pageNumberLimit);
      setMinLimit(minPageLimit - pageNumberLimit);
    }
  };
  const handleNextBtn = (e) => {
    if (currentPage === pages.length) {
      return;
    }
    setPage(currentPage + 1);
    setCurrentPage(currentPage + 1);
    if (currentPage + 1 > maxPageLimit) {
      setMaxLimit(maxPageLimit + pageNumberLimit);
      setMinLimit(minPageLimit + pageNumberLimit);
    }
  };
  const renderPageNumbers = pages
    ? pages.map((number, index) => {
        if (number < maxPageLimit + 1 && number > minPageLimit) {
          return (
            <li
              key={index}
              className={
                currentPage === number ? "page-item active" : "page-item"
              }
              style={{ cursor: "pointer" }}
              onClick={(e) => handleClick1(e)}
            >
              <a
                href="#overview-page"
                className="page-link pb-2 ps-3 pt-2 pe-3"
                id={number}
              >
                {number}
              </a>
            </li>
          );
        } else return null;
      })
    : "";

  // ----------------------------- OverDue function ----------------------------
  function overDueCalculation(date) {
    const currentDate = new Date();
    console.log(currentDate, date);
    // Calculate difference between two dates in milliseconds
    const differenceInMs = currentDate - date;
    // Convert milliseconds to days
    const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24);
    console.log(differenceInDays);
    if (differenceInDays >= 3 && differenceInDays < 7) return "#E8880C";
    if (differenceInDays >= 7 && differenceInDays <= 10) return "#36A206";
    if (differenceInDays > 10) return "#D22F4C";
    // else return "gray";
  }

  const getPaymentStatus = (row) => {
    if (state.payment_info) {
      return row?.only_bnps?.payment_info ? row?.only_bnps?.payment_info : "NA";
    } else if (state.supplier_payment_info) {
      return row?.only_bnps?.supplier_payment_info
        ? row?.only_bnps?.supplier_payment_info
        : "NA";
    }
    return row?.only_bnps?.collection_status
      ? row?.only_bnps?.collection_status
      : "NA";
  };

  return (
    <div className=" ms-0 ps-0 m-2 pt-0">
      {state.approval === "Overdue" ? (
        <OMSOverdue state={state} searchOrderId={searchOrderId} />
      ) : (
        <>
          {" "}
          {overDueAgenstLoading !== "" ? (
            <div className="mt-0 d-flex justify-content-between">
              <div className="d-flex ">
                {" "}
                <div className="fw-bolder mt-2" style={{ fontSize: "16px" }}>
                  Overdue Legends:
                </div>
                <div className="p-2 me-1">
                  <button
                    className="ps-1 pe-1"
                    style={{
                      backgroundColor: "#E8880C",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: "14px",
                    }}
                    disabled
                  >
                    More than 3 days
                  </button>{" "}
                  {/* <span style={{ fontSize: "14px" }}>Range 0 to 120</span> */}
                </div>
                <div className="p-2 me-1">
                  <button
                    className="ps-1 pe-1"
                    style={{
                      backgroundColor: "#36A206",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: "14px",
                    }}
                    disabled
                  >
                    More than 7 days
                  </button>{" "}
                  {/* <span style={{ fontSize: "14px" }}>Range 121 to 200</span> */}
                </div>
                <div className="p-2 me-1">
                  <button
                    className="ps-1 pe-1"
                    style={{
                      backgroundColor: "#D22F4C",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: "14px",
                    }}
                    disabled
                  >
                    More than 10 days
                  </button>{" "}
                  {/* <span style={{ fontSize: "14px" }}>Range 201 to 280</span> */}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          <div>
            <TableContainer component={Paper} className="overflow-x-scroll">
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead className="shadow text-light">
                  <TableRow className="p-2 ">
                    <TableCell align="center" className="text-light">
                      Ordered Date
                    </TableCell>
                    <TableCell className="text-light" align="center">Order ID</TableCell>
                    <TableCell className="text-light" align="center">Buyer Name</TableCell>
                    <TableCell className="text-light" align="center">Supplier Name</TableCell>
                    <TableCell className="text-light" align="center">Approval Status</TableCell>
                    <TableCell className="text-light" align="center">Buyer Paid Amount</TableCell>
                    <TableCell className="text-light" align="center">Supplier Paid Amount</TableCell>
                    {overDueAgenstLoading !== "" ? (
                      <TableCell className="text-light">Supplier Loading Date</TableCell>
                    ) : (
                      ""
                    )}

                    <TableCell className="text-light" align="center">Payment Status</TableCell>
                    {/* <TableCell align="center">Gross Margin</TableCell>
                    <TableCell align="center">Net Margin</TableCell> */}

                    <TableCell className="text-light" align="center">View</TableCell>
                  </TableRow>
                </TableHead>
                {loading ? (
                  <>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      <ClipLoader />
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </>
                ) : (
                  <TableBody>
                    {omsData?.length === 0 ? (
                      <>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="center">No Data Found</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                      </>
                    ) : (
                      omsData?.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell align="center" style={{ width: "120px" }}>
                            {row?.ordered_date
                              ? moment(row?.ordered_date).format("DD-MM-YYYY")
                              : "NA"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.only_bnps?.order_id
                              ? row?.only_bnps?.order_id
                              : "NA"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.buyer_shop?.name
                              ? row?.buyer_shop?.name
                              : "NA"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.op_sourcing_details?.[0]?.firm_name
                              ? row?.op_sourcing_details?.[0]?.firm_name
                              : "NA"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.only_bnps?.ayekart_lvl1_status ===
                              "Approved" &&
                            row?.only_bnps?.ayekart_lvl2_status === "Approved"
                              ? "Approved"
                              : "Pending"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.only_bnps?.paid_amount
                              ? row?.only_bnps?.paid_amount
                              : "NA"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.only_bnps?.supplier_total_transfer_amt
                              ? row?.only_bnps?.supplier_total_transfer_amt
                              : "NA"}
                          </TableCell>
                          {overDueAgenstLoading !== "" ? (
                            <TableCell align="center">
                              {row?.only_bnps?.due_date ? (
                                <button
                                  className="p-2"
                                  disabled
                                  style={{
                                    backgroundColor: `${overDueCalculation(
                                      row?.supplier_loading_time
                                        ? new Date(row?.supplier_loading_time)
                                        : new Date()
                                    )}`,
                                    color: "#fff",
                                    borderRadius: "10px",
                                  }}
                                >
                                  {row?.supplier_loading_time
                                    ? new Date(
                                        row?.supplier_loading_time
                                      ).toLocaleDateString()
                                    : "NA"}
                                </button>
                              ) : (
                                "NA"
                              )}
                            </TableCell>
                          ) : (
                            ""
                          )}
                          <TableCell align="center">
                            {getPaymentStatus(row)}
                          </TableCell>

                          {/* <TableCell align="center">
                            {(row?.only_bnps?.total_sp
                              ? parseFloat(row?.only_bnps?.total_sp)
                              : 0) - row?.only_bnps?.total_cp
                              ? parseFloat(row?.only_bnps?.total_cp)
                              : 0}
                          </TableCell>
                          <TableCell align="center">{"NA"}</TableCell> */}
                          <TableCell align="center">
                            <div>
                              <Button
                                variant="outlined"
                                onClick={() =>
                                  navigate(`/oms/${row?.only_bnps?.order_id}`)
                                }
                              >
                                View
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                )}
              </Table>
              {omsData?.length !== 0 && (
                <div className="row mx-auto mt-3">
                  <div className="col-sm-6 pt-2 d-flex justify-content-start">
                    Showing {15 * currentPage - (15 - 1)} to{" "}
                    {15 * currentPage > totalResults
                      ? totalResults
                      : 15 * currentPage}{" "}
                    entries of {totalResults ? totalResults : ""}
                  </div>
                  <div className="col-sm-6 d-flex justify-content-end">
                    <ul className="pagination">
                      <li className="page-item pt-1 pl-2 pr-2 border">
                        <a
                          href="#overview-page"
                          className={
                            currentPage !== pages[0] ? "show" : "hideBtn"
                          }
                          onClick={(e) => handlePrevBtn(e)}
                        >
                          Prev
                        </a>
                      </li>
                      {renderPageNumbers}
                      <li className="page-item pt-1 pl-2 pr-2 border border-left-0">
                        <a
                          href="#overview-page"
                          className={
                            currentPage !== pages.length ? "show" : "hideBtn"
                          }
                          onClick={(e) => handleNextBtn(e)}
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </TableContainer>
          </div>
        </>
      )}
    </div>
  );
}

export default OMSApproved;
